import Vue from 'vue'
import Vuex from 'vuex'
import app from '../../main' // import the instance
import axios from 'axios' // remove comment if yu needed
import Crud from '../crud'
import checkResponse from '@/utils/checkResponse'
const model = (payload) => ({
  // columns
  id: payload.id
})
var crud = new Crud('ChangeOrders', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  changeOrders: []
}

const mutations = {
  ...crud.mutations,
  ADD_PDF (state, payload) {
    const idx = state.changeOrders.findIndex(u => u.id === payload.id)
    state.changeOrders[idx] = payload
    if (idx >= 0) {
      Vue.set(state.changeOrders, idx, payload)
    }
  },
  DELETE_CHANGE_ORDER (state, payload) {
    const idx = state.changeOrders.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.delete(state.changeOrders, idx)
    }
  }
}

const actions = {
  ...crud.actions,
  export ({ commit }, payload) {
    app.$Progress.start()
    try {
      window.open(payload)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async editChangeOrder ({ commit }, payload) {
    app.$Progress.start()
    const formData = new FormData()
    formData.append('file', payload.file)
    formData.append('_method', 'PUT')

    try {
      const response = await axios.post(`change-orders/${payload.id}`, formData)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('ADD_PDF', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.change_orders', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async deleteRecord ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`change-orders/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit(
          'SET_ALERT_MESSAGE',
          {
            color: 'danger',
            title: 'errors.connection_error',
            text: checkErrors.message
          },
          { root: true }
        )
      } else {
        commit(`DELETE_CHANGE_ORDER`, payload)
        commit('SET_MODAL_VISIBLE', false)
        commit(
          'SET_ACCEPT_ALERT',
          {
            color: 'success',
            title: `strings.change_orders`,
            text: 'front.deleted_successfully',
            icon: 'checkmark-circle-outline'
          },
          { root: true }
        )
      }
    } catch (e) {
      app.$Progress.fail()
      commit(
        'SET_ALERT_MESSAGE',
        {
          color: 'danger',
          title: 'errors.connection_error',
          text: 'errors.generic_error'
        },
        { root: true }
      )
    } finally {
      app.$Progress.finish()
    }
  }

}

const getters = {
  ...crud.getters,
  changeOrders: state => state.changeOrders
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
